export default __webpack_public_path__ + "static/media/loading.30910806.png";